import { IMaskedIcon, MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import theme from '@/theme';
import styled from '@emotion/styled';

export const IconContainer = styled.div<{ disabled?: boolean }>`
    cursor: pointer;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ disabled }) => disabled && 'opacity: 0.5; cursor: not-allowed;'}

    &:hover {
        border-radius: 6px;
        background: ${theme.colors.black[200]};
    }
`;

const StyledMaskedIcon = styled(MaskedIcon)`
    color: ${theme.colors.secondary.main};
`;

type Props = Omit<IMaskedIcon, 'onClick'> & { onClick: () => void };

export const IconWithHover = ({ onClick, ...props }: Props) => {
    return (
        <IconContainer onClick={onClick}>
            <StyledMaskedIcon {...props} />
        </IconContainer>
    );
};
